module.exports = __webpack_public_path__ + "static/media/employee.5c576d12.png";